import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import EmbedCloseButton from './EmbedCloseButton';
import LocatorWrapper from '../locator/LocatorWrapper';

export class EmbedOverlayLocator extends Component {
  render() {
    const { defaultViewport, doesMapGeolocate, mapboxClientKey, showing } = this.props;

    return (
      <div className="closeby-overlay">
        <div className={`closeby-overlay-content ${showing ? 'showing' : ''}`}>
          <EmbedCloseButton />
          <LocatorWrapper
            mapboxClientKey={mapboxClientKey}
            defaultViewport={defaultViewport}
            doesMapGeolocate={doesMapGeolocate}
            cachable
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.embed
  }
};

EmbedOverlayLocator.propTypes = {
  defaultViewport: PropTypes.object,
  doesMapGeolocate: PropTypes.bool.isRequired,
  mapboxClientKey: PropTypes.string.isRequired
}

export default connect(mapStateToProps)(EmbedOverlayLocator);
